<template>
  <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm p-4">
    <div class="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 border border-gray-100 animate-in fade-in zoom-in-95 duration-150">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-bold text-gray-900 flex items-center gap-2">
          <i class="fa fa-file-upload text-orange-500" />
          <span>Importar Inventario desde Excel</span>
        </h3>
        <button 
          type="button"
          class="text-gray-400 hover:text-gray-600 cursor-pointer p-1" 
          @click="handleClose"
        >
          <i class="fa fa-times" />
        </button>
      </div>
      
      <div class="space-y-4">
        <p class="text-sm text-gray-600">
          Selecciona un archivo Excel (.xlsx, .csv) con el formato requerido para cargar registros de inventario.
        </p>
        
        <div class="border-2 border-dashed border-gray-200 hover:border-orange-500 rounded-xl p-6 text-center transition-colors bg-gray-50/50">
          <input 
            id="excel-file-input" 
            ref="fileInputRef" 
            type="file" 
            accept=".xlsx, .xls, .csv" 
            class="hidden" 
            @change="handleFileUpload" 
          />
          <label for="excel-file-input" class="cursor-pointer flex flex-col items-center">
            <i class="fa fa-cloud-upload-alt text-3xl text-orange-500 mb-2" />
            <span class="text-sm font-medium text-gray-700">Haz clic aquí para seleccionar tu archivo Excel</span>
            <span class="text-xs text-gray-400 mt-1">Formatos soportados: .xlsx, .xls, .csv</span>
            <div v-if="selectedFile" class="mt-3 px-3 py-1.5 bg-orange-100 text-orange-800 rounded-full text-xs font-semibold flex items-center gap-1.5">
              <i class="fa fa-check-circle text-orange-600" />
              <span>{{ selectedFile.name }}</span>
            </div>
          </label>
        </div>

        <div class="flex justify-end gap-2 pt-2">
          <button 
            type="button"
            class="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-sm font-medium cursor-pointer transition-colors" 
            @click="handleClose"
          >
            Cancelar
          </button>
          <button 
            type="button"
            :disabled="!selectedFile" 
            class="px-4 py-2 bg-orange-500 hover:bg-orange-600 disabled:opacity-50 text-white rounded-lg text-sm font-medium shadow-sm transition-colors cursor-pointer active:scale-95" 
            @click="handleSubmit"
          >
            Subir e Importar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventoryImportModal',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['close', 'submit-file'],

  data() {
    return {
      selectedFile: null,
    }
  },

  watch: {
    isOpen(val) {
      if (!val) {
        this.selectedFile = null
        if (this.$refs.fileInputRef) {
          this.$refs.fileInputRef.value = ''
        }
      }
    },
  },

  methods: {
    handleFileUpload(event) {
      this.selectedFile = event.target.files[0] || null
    },

    handleSubmit() {
      if (!this.selectedFile) return
      this.$emit('submit-file', this.selectedFile)
    },

    handleClose() {
      this.selectedFile = null
      this.$emit('close')
    },
  },
}
</script>
